module.exports = __webpack_public_path__ + "fa-regular-400.f817938f131b0cabee81.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.woff2
// module id = ./src/assets/webfonts/fa-regular-400.woff2
// module chunks = styles